import { get, set, del, clear } from 'idb-keyval';

import Singleton from '../Singleton';
import ErrorService from './ErrorService';

/**
 * Wrapper around idb-keyval for Simplified IndexDB access
 * allows for get set and remove item as a key value pair from IndexDB
 * NOTE all operations use an IndexedDB database named keyval-store and
 * an object store named keyval
 */
class IndexDBStoreService extends Singleton<IndexDBStoreService> {
  /**
   * Gets value associated with key
   */
  static async getItem(key: string): Promise<any> {
    let val;
    try {
      val = await get(key);
    } catch (e) {
      ErrorService.trackError(e);
    }
    return val;
  }

  /**
   * Sets a key value pair in the keyval-store
   */
  static async setItem(key: string, value: any): Promise<void> {
    try {
      await set(key, value);
    } catch (e) {
      ErrorService.trackError(e);
    }
  }

  /**
   * Removes a specific key value from the keyval-store
   */
  static async removeItem(key: string): Promise<void> {
    try {
      await del(key);
    } catch (e) {
      ErrorService.trackError(e);
    }
  }

  /**
   * Clear all items in the indexdb store keyval
   * NOTE this operation will delete the entire database
   */
  static async clearStore(): Promise<void> {
    try {
      await clear();
    } catch (e) {
      ErrorService.trackError(e);
    }
  }
}

export default IndexDBStoreService;
